"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

// typescript import
// import
// definition
var _default = function _default(hook) {
  return function (Component) {
    var WithHook = function WithHook(props) {
      return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, hook(props)));
    };

    WithHook.getInitialProps = Component.getInitialProps;
    return WithHook;
  };
};

exports["default"] = _default;